<template>
  <!-- TODO(Vue3): use transition as root may be a wrong decision in Vue3: https://v3-migration.vuejs.org/breaking-changes/transition-as-root.html -->
  <transition name="fade">
    <component :is="layout" />
  </transition>
</template>

<script setup>
import { computed, defineAsyncComponent, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { AUTH_GETTERS } from '@/shared/constants/store-constants/auth'
import { usePartner } from '@/shared/composables/usePartner'
import { PRODUCT_NAMES } from '@/shared/constants/products'
import { MASS_PAYMENTS_DISPATCHERS } from '@/shared/constants/store-constants/massPayments'

const SYSTEM_LAYOUT = 'system'
const MAIN_LAYOUT = 'main'
const GLOBAL_LAYOUT = 'global'
const AUTH_LAYOUT = 'auth'

const LAYOUT_CONFIG = {
  [SYSTEM_LAYOUT]: defineAsyncComponent(
    () => import('@/app/layouts/system.vue')
  ),
  [MAIN_LAYOUT]: defineAsyncComponent(() => import('@/app/layouts/app.vue')),
  [GLOBAL_LAYOUT]: defineAsyncComponent(
    () => import('@/app/layouts/global.vue')
  ),
  [AUTH_LAYOUT]: defineAsyncComponent(() => import('@/app/layouts/auth.vue')),
}

const route = useRoute()
const store = useStore()
const { isProductAvailable, isLoaded, products } = usePartner()

const isAuthorized = store.getters[AUTH_GETTERS.isAuthorized]

const layout = computed(() => {
  const { layout, isNeedAuth } = route.meta
  if (isNeedAuth && isAuthorized) {
    return LAYOUT_CONFIG[layout || MAIN_LAYOUT]
  }
  return LAYOUT_CONFIG[layout || SYSTEM_LAYOUT]
})

async function checkAndFetchTermsStatus() {
  if (!isLoaded.value) return

  if (isProductAvailable(PRODUCT_NAMES.MASS_PAYMENTS)) {
    await store.dispatch(MASS_PAYMENTS_DISPATCHERS.getTermsStatus)
  }
}

watch(
  [products, isAuthorized],
  () => {
    checkAndFetchTermsStatus()
  },
  { immediate: true }
)
</script>

<style scoped></style>
